declare const __OFFLINE_BUILD__: boolean;
declare const __OFFLINE_BUILD_ID__: string;
let registration: ServiceWorkerRegistration | null = null;
let updateAvailable = false;
let shellState = 'preparing';
export const offlineShellState = () => shellState;
export const hasOfflineUpdate = () => updateAvailable;
export function applyOfflineUpdate() {
  if (!registration?.waiting) return;
  navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), { once: true });
  registration.waiting.postMessage({ type: 'ACTIVATE_UPDATE' });
}
export function registerOfflineShell() {
  if (!__OFFLINE_BUILD__) { shellState = 'development'; return; }
  if (!('serviceWorker' in navigator)) { shellState = 'unsupported'; return; }
  const notifyState = () => window.dispatchEvent(new Event('sonata-offline-update'));
  const install = () => {
    navigator.serviceWorker.register('/sw.js', {updateViaCache:'none'}).then(worker => {
      registration = worker;
      const checkVersion=async()=>{
        const active=navigator.serviceWorker.controller||worker.active;
        if(!active){shellState='preparing';notifyState();return;}
        const version=await new Promise<string|null>(resolve=>{
          const channel=new MessageChannel();const timer=setTimeout(()=>{channel.port1.close();resolve(null);},2000);
          channel.port1.onmessage=event=>{clearTimeout(timer);channel.port1.close();resolve(event.data?.version||null);};
          active.postMessage({type:'GET_SHELL_VERSION'},[channel.port2]);
        });
        shellState=version?.startsWith(`sonata-shell-${__OFFLINE_BUILD_ID__}-`)?'ready':'update-required';notifyState();
      };
      void navigator.serviceWorker.ready.then(checkVersion);
      navigator.serviceWorker.addEventListener('controllerchange',()=>void checkVersion());
      const notify = () => {
        updateAvailable = !!worker.waiting&&!!worker.active;
        window.dispatchEvent(new Event('sonata-offline-update'));
      };
      notify();
      worker.addEventListener('updatefound', () => worker.installing?.addEventListener('statechange', notify));
      const check = () => { if (document.visibilityState === 'visible' && navigator.onLine) void worker.update().catch(() => {}); };
      document.addEventListener('visibilitychange', check);
      window.addEventListener('online', check);
    }).catch(error => { shellState = 'failed'; notifyState(); console.warn('Offline startup unavailable', error); });
    navigator.storage?.persist?.().catch(() => {});
  };
  install();
}
